<template>
<!-- <div class="form-body">
    <div class="row pagelogin">
      <div class="img-holder">
        <div class="bg" :style="bannerImages"></div>
        <div class="info-holder"></div>
      </div>
      <div class="form-holder loginpagestyle">
        <div class="form-content">
          <div class="form-items toplogin">
            <span class="logo" v-html="logos"></span>
            <h3 class="login-welcome-back" style="margin-top: 15px;">Welcome to screenit</h3>
            <p style="text-align: center;margin-bottom: 10px;font-size: 14px">Sign In to stay updated on all new world.</p>
              <br> -->
  <div class="con">
    <div class="row">
      <div class="col login">
        <form method="post" v-on:submit.prevent="signUp" v-if="isHidden">
          <div class="logo">
<div class="img-holder">
        <div class="bg" :style="bannerImages"></div>
        <div class="info-holder"></div>
      </div>
          </div>
          <div class="container">
            <div class="form-group formdata">
              <div class="welcometitle">
                            <span class="logo" style="justify-content:center" v-html="logos"></span>
              <h4>Welcome to screenit</h4><small>Sign In to stay updated on all new world.</small></div>
              <br>
            <div class="form-group">
              <label for="exampleInputEmail1">Email address</label>
              <input
                v-model="user.userEmail"
                type="email"
                class="form-control inputfield"
                id="email"
                @keyup="clear()"
                name="email"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                :class="{ 'is-invalid': submitted && $v.user.userEmail.$error }"
              />
              <div
                  v-if="submitted && $v.user.userEmail.$error"
                  class="invalid-feedback" style="color:red"
                >
                  <span v-if="errormsg == 'Email is Required'">Email is required*</span>
                  <span v-if="!$v.user.userEmail.email">Email is invalid*</span>
                </div>
                <div class="invalid-feedback" style="color:red">
                  <span v-if="errormsg == 'Email already exists'">Email already exists</span>
                </div>
            </div>
            <br>
            <div class="signinbtn">
              <!-- <button type="submit" class="btn btn-success" style="width:100%">Send OTP</button> -->
              <button type="submit" class="btn btn-success" style="width:100%">Send OTP</button>
              </div>
              <br>
              <br>
              <div class="signup">
              <small>Already have an account? <span ><button style="color:#5bad2b; background:transparent"  @click="userLogin" class="btn"
              >Sign In</button
            ></span>
              </small>
              </div>
              </div>
              </div>
        </form>
      </div>
    </div>
    <br>
<div class="login-box">
  <div class="login-logo">
    <!-- <span class="logo" v-html="logos"></span> -->
  </div>
  <!-- /.login-logo -->
  <div class="login-box-body" v-show='toggle' >
    <!-- <div class="box-header fgpswd with-border mb-10" >
      <h4 class="box-title pull-left fgpswd">Verify OTP</h4>
    </div> -->
        <div class="verificationcode" id="hide" v-show='toggle' style="display:none">
          <div class="title"><h4>Verification Code</h4>
          <p class="title">OTP has been sent to your registered email. Please enter to verify</p>
          <fieldset class='number-code'>
    <div class="userInput">
<input v-model="manualotp1" type="text" v-on:keyup="changefocus(1)" v-on:keypress="NumbersOnly" class="otp" id='otp1' maxlength="1">
<input v-model="manualotp2" type="text" v-on:keyup="changefocus(2)" v-on:keypress="NumbersOnly" class="otp" id="otp2" maxlength="1">
<input v-model="manualotp3" type="text" v-on:keyup="changefocus(3)" v-on:keypress="NumbersOnly" class="otp" id="otp3" maxlength="1">
<input v-model="manualotp4" type="text" v-on:keyup="changefocus(4)" v-on:keypress="NumbersOnly" class="otp" id="otp4" maxlength="1">
<input v-model="manualotp5" type="text" v-on:keyup="changefocus(5)" v-on:keypress="NumbersOnly" class="otp" id="otp5" maxlength="1" >
<input v-model="manualotp6" type="text" v-on:keyup="changefocus(6)" v-on:keypress="NumbersOnly" class="otp" id="otp6" maxlength="1">
</div>
  <p v-if="invalidOTP" class="tc" style="color:red">Invalid OTP</p>
  <p v-if="requiredOTP" class="tc" style="color:red">* Please enter the OTP</p>
  </fieldset>
  <br><button to="/Interviewer_BasicProfile" type="submit" class="btn btn-success" style="width:50%" v-on:click.prevent="verify">Verify</button>
  <br>
  <br>
  <button class="btn" style="background:transparent;color:#5BAD2B" @click="signUp(2)">Resend OTP</button>
          </div>
        </div>
  </div>
  </div>
  </div>
</template>
<script>
import axios from 'axios'
import Vuelidate from 'vuelidate'
import { BaseURL } from '../../shared/classes'
import { required, email } from 'vuelidate/lib/validators'
import Vue from 'vue'
import bannerImage from '../../assets/img/login-image.jpg'
import { logo } from '../../shared/svg'
// import router from '../../router/index'
import $ from 'jquery'
Vue.use(Vuelidate, axios)

export default {
  name: 'LoginPage',
  data () {
    return {
      user: {
        userEmail: ''
      },
      userdetails: '',
      submitted: false,
      bannerImages: `background-image: url(${bannerImage})`,
      logos: logo,
      isHidden: true,
      toggle: false,
      invalidOTP: false,
      requiredOTP: false,
      otpvalue: '',
      manualotp1: '',
      manualotp2: '',
      manualotp3: '',
      manualotp4: '',
      manualotp5: '',
      manualotp6: '',
      signUpMsg: '',
      errormsg: ''
    }
  },
  validations: {
    user: {
      userEmail: { required, email }
    }
  },
  computed: {
    isValid () {
      return !this.$v.$invalid
    },
    isDirty () {
      return this.$v.user.$anyDirty
    }
  },
  methods: {
    changeNext (e) {
      console.log(e)
      const child = e.childNode
      child.focus()
    },
    clear () {
      this.errormsg = ''
    },
    userLogin () {
      this.$router.push('/LoginPage')
    },
    changefocus (len) {
      var next = Number(len) + 1
      console.log(next)
      if ($('#otp' + len).val()) {
        this.invalidOTP = false
        $('#otp' + next).focus()
      }
    },
    NumbersOnly (evt) {
      this.requiredOTP = false
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    verify () {
      this.invalidOTP = false
      this.requiredOTP = false
      this.submitted = true
      this.otpvalue = Number(this.manualotp1 + this.manualotp2 + this.manualotp3 + this.manualotp4 + this.manualotp5 + this.manualotp6)
      console.log(this.otpvalue)
      if (!this.otpvalue) {
        this.requiredOTP = true
      } else if (this.otpvalue === this.userdetails) {
        this.$router.push('/Interviewer_BasicProfile')
      } else {
        this.manualotp1 = ''
        this.manualotp2 = ''
        this.manualotp3 = ''
        this.manualotp4 = ''
        this.manualotp5 = ''
        this.manualotp6 = ''
        this.invalidOTP = true
      }
    },
    signUp () {
      this.submitted = true
      if (this.user.userEmail === '') {
        this.errormsg = 'Email is Required'
        this.toggle = false
      } else {
        this.clear()
        const formData = new FormData()
        formData.append('user_email', this.user.userEmail)
        console.log(this.user.userEmail)
        const data = {
          user_email: this.user.userEmail.toLowerCase()
        }
        axios.post(BaseURL + '/email/send_email_otp', { formData: data })
          .then(response => {
            console.log(response)
            this.errormsg = ''
            this.errormsg = response.data.message
            this.signUpMsg = response.data.message
            if (this.signUpMsg === 'Success') {
              this.isHidden = false
              this.userdetails = response.data.otp
              console.log(this.userdetails)
              if (this.toggle) {
                this.manualotp1 = ''
                this.manualotp2 = ''
                this.manualotp3 = ''
                this.manualotp4 = ''
                this.manualotp5 = ''
                this.manualotp6 = ''
                this.invalidOTP = true
                this.isHidden = false
              } else {
                this.toggle = true
                this.invalidOTP = false
                this.isHidden = false
              }
              localStorage.setItem('user_email', this.user.userEmail)
              this.$awn.success('OTP sent to Mail successfully')
            } else {
              this.toggle = false
              this.signUpMsg = response.data.message
            }
          })

          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  width: 400px;
}
.login {
  column-count: 2;
}
.formdata {
  width: 75%;
  padding-top: 100%;
}
#bnrimg {
  width: 100%;
  height: 650px;
  max-width: 400px;
}
.signinbtn{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

}
.signup{
  display: flex;
  justify-content: center;
}
.welcometitle{
  text-align: center;
}
.verificationcode{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
}
.userInput{
display: flex;
justify-content: center;
}
.otp{
margin: 10px;
height: 35px;
width: 50px;
border: none;
border-radius: 5px;
text-align: center;
font-family: arimo;
font-size: 16px;
font-weight: 700;
background: #eef2f3;
}
.otp:focus-visible {
  outline: 4px solid #5bad2b;
  border-radius: 2px !important;
}
.title{
  text-align: center;
}
.hide{
  visibility: hidden;
}
@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
  .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
.container{
  margin-left: 10%;
}
.bg{
  width:80%
}
.userInput{
display: flex;
justify-content: center;
}
.otp{
margin: 6px;
height: 35px;
padding: 4px;
width: 40px;
border: none;
border-radius: 5px;
text-align: center;
font-family: arimo;
font-size: 16px;
font-weight: 700;
background: #eef2f3;
}
}
 @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
   .bg{
    display: none;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
.login {
  column-count: 1;
}
.container{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.formdata {
  width: 75%;
  padding-top: 10%;
}
 }
   @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
      .bg{
    display: none;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
.login {
  column-count: 1;
}
.container{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.formdata {
  width: 75%;
  padding-top: 10%;
}
.userInput{
display: flex;
justify-content: center;
}
.otp{
margin: 6px;
width: 40px;
height: 40px;
padding: 4px;
}
   }
</style>
